var _rect, _rect2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrafterTagChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#E2E2E2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60938 17.2772L7.80382 19.0039L9.06381 17.8061L11.2182 11.895C10.6894 11.7628 10.2227 11.4984 9.84158 11.1328L7.60938 17.2772Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1501 11.1328C13.769 11.4984 13.2945 11.7628 12.7734 11.895L14.9279 17.8061L16.1879 19.0039L16.3901 17.2772L14.1501 11.1328Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.284 9.35553C14.5174 8.1422 13.8174 7.06887 12.7752 6.69554V5.77777C12.7752 5.35 12.4252 5 11.9974 5C11.5696 5 11.2196 5.35 11.2196 5.77777V6.69554C10.3174 7.02221 9.66406 7.87776 9.66406 8.88886C9.66406 10.32 10.9552 11.4555 12.4329 11.1833C13.3507 11.0122 14.1051 10.2733 14.284 9.35553ZM11.9974 9.66664C11.5696 9.66664 11.2196 9.31664 11.2196 8.88886C11.2196 8.46109 11.5696 8.11109 11.9974 8.11109C12.4252 8.11109 12.7752 8.46109 12.7752 8.88886C12.7752 9.31664 12.4252 9.66664 11.9974 9.66664Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafterTagChecked);
export default __webpack_public_path__ + "static/media/drafter_tag_checked.f041470d.svg";
export { ForwardRef as ReactComponent };